import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './styles.css';

export class Footer extends Component {
    static displayName = Footer.name;

    render() {
        return (
            <footer>
                <Container className='footerSection'>
                    <Row>
                        <Col md={6} sm={12}>
                            <div>
                                <h3>Social</h3>
                                {/*<i className="fab fa-facebook"></i>*/}
                                <span className='span-fa-social'><a href='http://www.facebook.com/PacificMoto' target='_blank' title='Pacific Facebook'><FontAwesomeIcon icon={['fab', 'facebook-square']} size="lg" /></a></span>
                                <span className='span-fa-social'><a href='http://www.twitter.com/pacificmoto' target='_blank' title='Pacific Twitter'><FontAwesomeIcon icon={['fab', 'twitter']} size="lg" /></a></span>
                                {/*<span className='span-fa-social'><a href='http://www.pinterest.com/pacmoto/' target='_blank' title='Pacific Pinterest'><FontAwesomeIcon icon={['fab', 'pinterest-square']} size="lg" /></a></span>*/}
                                <span className='span-fa-social'><a href='http://vimeo.com/pacificmotosports' target='_blank' title='Pacific Vimeo'><FontAwesomeIcon icon={['fab', 'vimeo-square']} size="lg" /></a></span>
                                <span className='span-fa-social'><a href='http://www.instagram.com/pacificmotosports' target='_blank' title='Pacific Instagram'><FontAwesomeIcon icon={['fab', 'instagram']} size="lg" /></a></span>
                                {/*<span className='span-fa-social'><a href='http://blog.pacificmotosports.com/' target='_blank' title='Pacific Blog'><FontAwesomeIcon icon={['fab', 'wordpress']} size="lg" /></a></span>*/}
                            </div>
                        </Col>
                        <Col md={6} sm={12}>
                            <div className='footer-contact-us'>
                                <h3 id="contact-us">Contact Us</h3>
                                <span><i><FontAwesomeIcon icon="phone-square" size="lg" rotation={90} flip="horizontal" /></i>604-276-2552</span><br />
                                <span><i><FontAwesomeIcon icon="map-marker-alt" size="lg" /></i>100-6260 Graybar Road. Richmond, BC V6W 1H6, Canada</span><br />
                                <span><i><FontAwesomeIcon icon="envelope" size="lg"/></i>info@pacificmotosports.com</span><br />
                            </div>
                        </Col>
                    </Row>
                </Container >
            </footer >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer/index.js